export enum ErrorKeyCodeEnum {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  SILENCED_INTERNAL_ERROR = 'SILENCED_INTERNAL_ERROR',
  UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  BAD_REQUEST = '400',
}

interface ApplicationError {
  keyCode: ErrorKeyCodeEnum;
  message: string;
  shouldNotify: boolean;
}

export const INTERNAL_ERROR: ApplicationError = {
  keyCode: ErrorKeyCodeEnum.INTERNAL_ERROR,
  message: 'Erro interno do sistema, tente novamente.',
  shouldNotify: true,
};

export const SILENCED_INTERNAL_ERROR: ApplicationError = {
  keyCode: ErrorKeyCodeEnum.SILENCED_INTERNAL_ERROR,
  message: '',
  shouldNotify: false,
};

export const UNAUTHORIZED_ERROR = {
  keyCode: ErrorKeyCodeEnum.UNAUTHORIZED_ERROR,
  message: 'Operacao nao autorizada.',
  shouldNotify: false,
};

export const INVALID_CREDENTIALS = {
  keyCode: ErrorKeyCodeEnum.INVALID_CREDENTIALS,
  message: 'Dados de acesso incorretos.',
  shouldNotify: true,
};

export const BAD_REQUEST = {
  keyCode: ErrorKeyCodeEnum.BAD_REQUEST,
  message: 'Erro interno do sistema, tente novamente.',
  shouldNotify: true,
};

export const ERROR: Record<ErrorKeyCodeEnum, ApplicationError> = {
  [ErrorKeyCodeEnum.INTERNAL_ERROR]: INTERNAL_ERROR,
  [ErrorKeyCodeEnum.SILENCED_INTERNAL_ERROR]: SILENCED_INTERNAL_ERROR,
  [ErrorKeyCodeEnum.UNAUTHORIZED_ERROR]: UNAUTHORIZED_ERROR,
  [ErrorKeyCodeEnum.INVALID_CREDENTIALS]: INVALID_CREDENTIALS,
  [ErrorKeyCodeEnum.BAD_REQUEST]: BAD_REQUEST,
};
